import { isNullish } from '@plugins/shared/utils/assertFunctions';

export function hasUserInteracted() {
  // Newly available (2023), might be undefined
  const userActivation = navigator.userActivation as UserActivation | undefined;

  if (isNullish(userActivation)) {
    return true;
  }

  return !!(userActivation.hasBeenActive && userActivation.isActive);
}
